import axios from '@/http/axios/index.js'


export default {
    getClients(payload) {
        return axios.get('expenses/notificacion/emails', { params: payload }).then(res => res.data)
    },
    updateEmails(payload) {
        return axios.post('expenses/notificacion/emails/update', payload ).then(res => res.data)
    },
    changeStatus(payload) {
        return axios.post('expenses/notificacion/emails/change-status', payload ).then(res => res.data)
    }
  
}